module.exports = __webpack_public_path__ + "img/page-03.776e1747.png";